import React from 'react';
import { array, func, object } from 'prop-types';

import HealthRecordListItem from '../HealthRecordListItem';

import s from './HealthRecordList.css';


const HealthRecordList = ({ ...props }) => {

  /*
    Ensure health record headers were returned, otherwise display a default no items message.
   */
  const recordHeaders = props.healthRecordHeaders;

  if (recordHeaders && recordHeaders.length > 0) {
    const healthRecordListItems = recordHeaders.map((healthRecordHeader) =>
      <HealthRecordListItem
        key={healthRecordHeader.id}
        id={healthRecordHeader.id}
        format={healthRecordHeader.format}
        from={healthRecordHeader.from}
        messageText={healthRecordHeader.messageText}
        time={healthRecordHeader.time}
        handleTransmitForm={props.handleTransmitForm}
        selectedHealthRecordListItem={props.selectedHealthRecordListItem}
        handleViewRecord={props.handleViewRecord}
      />
    );

    return (
      <section className={s.component}>
        {healthRecordListItems}
      </section>
    );
  }
  else {
    return (
      <section className={s.component}>
        <p className={s.messagePlaceholder}>
          No records to display
        </p>
      </section>
    );
  }

};

HealthRecordList.propTypes = {
  healthRecordHeaders: array,
  handleTransmitForm: func,
  handleViewRecord: func,
  selectedHealthRecordListItem: object,
};

export default HealthRecordList;



// WEBPACK FOOTER //
// ./src/components/Pages/Health/HealthRecordList/HealthRecordList.js